<template>
  <div class="profile rj-content">
    <h1>Mis consultas</h1>
    <p class="main-description">Agenda una consulta conmigo y analizaremos tu carta astral durante una sesión presencial
      o virtual, en la que te ayudaré a definir las acciones futuras adecuadas para alcanzar el éxito.</p>
    <v-card>
      <v-card-subtitle class="text-h5 font-weight-bold">Fecha de consulta</v-card-subtitle>
      <v-card-text class="text-body-1">01/08/2020</v-card-text>

      <v-card-subtitle class="text-h5 font-weight-bold">Motivo de consulta</v-card-subtitle>
      <v-card-text class="text-body-1">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusamus aliquid autem
        culpa dolores enim,
        eos id illum iure iusto mollitia non odit officiis provident quia quisquam sed, similique soluta unde! Lorem
        ipsum dolor sit amet, consectetur adipisicing elit. Consectetur debitis dolores fugit minima molestias
        necessitatibus quis repellat totam. Consequuntur doloribus enim eveniet fuga non pariatur perspiciatis quis
        tempora velit veniam?
      </v-card-text>

      <v-card-subtitle class="text-h5 font-weight-bold">Costo de consulta</v-card-subtitle>
      <v-card-text class="text-body-1">
        US$700
      </v-card-text
      >
      <v-card-subtitle class="text-h5 font-weight-bold">Modo de pago</v-card-subtitle>
      <v-card-text>
        <v-radio-group @change="otherMode" v-model="radiosMode" row>
          <v-radio label="Pago total" value="radioMode-1"></v-radio>
          <v-radio label="Pago parcial" value="radioMode-2"></v-radio>
        </v-radio-group>
      </v-card-text>

      <v-card-text v-if="mode">
        <v-row>
          <v-col cols="12" sm="4">
            <label for="">Monto US$</label>
            <v-text-field
                label=""
                required
                outlined
                dense
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-subtitle class="text-h5 font-weight-bold">Medio de pago</v-card-subtitle>
      <v-card-text>
        <v-radio-group @change="otherMedium" v-model="radiosTransfer" row>
          <v-radio label="Tarjeta de crédito/débito" value="radioTransfer-1"></v-radio>
          <v-radio label="Transferencia" value="radioTransfer-2"></v-radio>
        </v-radio-group>
      </v-card-text>

      <v-card-subtitle v-if="transfer" class="text-h5 font-weight-bold">Vaucher de pago</v-card-subtitle>
      <v-card-text v-if="transfer">
        <v-row>
          <v-col cols="12" sm="4">
            <template>
              <v-file-input label="Adjuntar tu archivo de pago" outlined dense></v-file-input>
            </template>
          </v-col>
        </v-row>
      </v-card-text>

      <v-dialog v-model="dialog" persistent max-width="500px">
        <template v-slot:activator="{ on, attrs }">
          <v-card>
            <v-card-text>
              <v-btn color="primary" large class="white--text" v-bind="attrs"
                     v-on="on">Pagar
              </v-btn>
            </v-card-text>
          </v-card>
        </template>
        <v-card>
          <v-card-title>

            <v-col>
              <v-col class="sm6">
                <v-img src="https://picsum.photos/510/300?random" width="150"></v-img>
              </v-col>
            </v-col>

            <v-col>
              <v-col class="sm12">
                <span>Ruben Jungbluth</span>
              </v-col>
              <v-col class="sm12">
                <p>Consulta personal</p>
              </v-col>
            </v-col>

          </v-card-title>

          <v-card-text>
            <hr class="secondary" size=2>


          </v-card-text>

          <v-card-text>

            <v-form>
              <v-row>

                <v-text-field
                    label="Número de Tarjeta"
                    outlined
                    class="sm12"
                ></v-text-field>


              </v-row>
              <v-row>
                <v-text-field
                    label="Mes/Año"
                    outlined
                    class="sm5 mr-1"
                ></v-text-field>

                <v-text-field
                    label="CVV"
                    outlined
                    class="sm5 ml-1"
                ></v-text-field>
              </v-row>

              <v-row>

                <v-text-field
                    label="Correo Electrónico"
                    outlined
                    class="sm12"
                ></v-text-field>


              </v-row>

              <v-row>

                <v-btn block color="#4DB6AC" :to="{name: 'PayConsultation2'}" large>
                  Pagar S/ 35.00 PEN
                </v-btn>


              </v-row>
            </v-form>

          </v-card-text>
        </v-card>

      </v-dialog>

      <v-dialog v-model="dialog2" persistent max-width="650px">
        <template v-slot:activator="{ on, attrs }">
          <v-card>
            <v-card-text>
              <v-btn color="primary" large class="white--text" v-bind="attrs"
                     v-on="on">Pagar
              </v-btn>
            </v-card-text>
          </v-card>
        </template>
        <v-card rounded class="pa-3">
          <v-row>
            <v-col class="text-end">
              <v-btn icon color="red" @click="dialog2 = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <div class="ctn-img text-center">
            <img src="../assets/logo.png"/>
          </div>
          <v-card-title>
          </v-card-title>
          <v-card-text>
            <p class="text-h6 text-center">¡Muchas gracias! <br> Pronto te notificaremos la transferencia de tu pago.
            </p>
          </v-card-text>
          <v-row class="text-center">
            <v-col>
              <v-btn color="primary" large>Continuar</v-btn>
            </v-col>
          </v-row>

        </v-card>

      </v-dialog>

    </v-card>
  </div>
</template>
<script>

export default {
  name: 'PayConsultation',
  data: () => ({
    dialog: false,
    dialog2: false,
    mode: false,
    radiosMode: 'radioMode-1',
    transfer: false,
    radiosTransfer: 'radioTransfer-1'
  }),
  methods: {
    otherMedium() {
      if (this.radiosTransfer === 'radioTransfer-2') {
        this.transfer = true
      } else {
        this.transfer = false
      }
    },
    otherMode() {
      if (this.radiosMode === 'radioMode-1') {
        this.mode = false
      } else {
        this.mode = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.profile {
  width: 100%;

  ::v-deep .v-expansion-panel {
    border-bottom: 1px solid #DEE3E6;
    margin-top: 0;

    > button {
      padding: 20px 8px 18px 8px;
      min-height: auto;
    }

    .v-expansion-panel-header {
      font-weight: 800;
      color: #656565;
      font-size: 20px;

      .v-expansion-panel-header__icon {
        margin-left: 8px;

        .v-icon {
          color: #B3B3B3 !important;
        }
      }
    }

    .v-expansion-panel-content__wrap {
      padding: 0 10px 16px;
    }
  }
}

.details {
  font-size: 12px;
  font-weight: 200;
}

.ctn-btn {
  font-weight: 200;
  margin-top: 20px;

  ::v-deep .v-btn {
    background-color: #2C8886;
  }

  label {
    margin-left: 12px;
    vertical-align: middle;
    font-weight: 200;
  }
}

.save-btn {
  margin: 35px 0 20px;
  text-transform: none;
  font-size: 14px;
  width: 160px;
  border-radius: 7px;
  height: 40px;
}


.phone-dial, .phone-value {
  display: inline-block;
  vertical-align: bottom;
}
</style>
